import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { IndustrialAnimatedBackground } from "@/shared/components/ui/IndustrialAnimatedBackground";
import "./LoginPage.css";

export function LoginPage() {
  const { login, status } = useAuth();
  const navigate = useNavigate();
  const [organizationCode, setOrganizationCode] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    const result = await login(organizationCode, email, password);
    if (result.ok) {
      navigate("/", { replace: true });
    } else {
      setError("اطلاعات ورود نادرست است. لطفاً کد سازمان، ایمیل یا نام کاربری، و رمز عبور را بررسی نمایید.");
    }
  }

  return (
    <main className="login-page">
      <IndustrialAnimatedBackground />

      <section className="login-content">
        <div className="login-brand">
          <div className="login-brand__title">فرایند</div>
          <div className="login-brand__subtitle">سامانه مدیریت و کنترل فرآیندهای تولید</div>
        </div>

        <div className="login-card">
          <div className="login-card__header">
            <h1>ورود به سیستم</h1>
            <p>برای ادامه وارد حساب کاربری خود شوید</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="organizationCode">شناسه یا کد سازمان (Tenant)</label>
              <input
                id="organizationCode"
                name="organizationCode"
                type="text"
                value={organizationCode}
                onChange={(e) => setOrganizationCode(e.target.value)}
                placeholder="demo-co"
                required
                dir="ltr"
              />
            </div>

            <div className="login-field">
              <label htmlFor="email">ایمیل یا نام کاربری</label>
              <input
                id="email"
                name="email"
                type="text"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@demo.local یا نام کاربری"
                required
                dir="ltr"
              />
            </div>

            <div className="login-field">
              <label htmlFor="password">رمز عبور</label>
              <input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                dir="ltr"
              />
            </div>

            {error && (
              <div
                style={{
                  backgroundColor: "rgba(239, 68, 68, 0.15)",
                  border: "1px solid rgba(239, 68, 68, 0.4)",
                  color: "#FCA5A5",
                  fontSize: "0.85rem",
                  textAlign: "center",
                  padding: "0.6rem 0.8rem",
                  borderRadius: "8px",
                  lineHeight: 1.4,
                  marginBottom: "18px",
                }}
                role="alert"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              className="login-submit"
              disabled={status === "authenticating"}
            >
              {status === "authenticating" ? "در حال اعتبارسنجی..." : "ورود به سیستم"}
            </button>
          </form>

          <div className="login-card__footer">
            سامانه سازمانی مدیریت فرآیند تولید
          </div>
        </div>

        <div className="login-developer">
          Powered by <strong>میمزاد</strong>
        </div>
      </section>
    </main>
  );
}
